import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMdiFacebook = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 29 29"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill="transparent" d="M.5.5h28v28H.5z" />
    <path
      fill="currentColor"
      d="M26.167 14.5c0-6.44-5.227-11.666-11.667-11.666S2.833 8.06 2.833 14.5c0 5.647 4.014 10.349 9.334 11.433V18H9.833v-3.5h2.334v-2.916A4.09 4.09 0 0 1 16.25 7.5h2.917V11h-2.334a1.17 1.17 0 0 0-1.166 1.167V14.5h3.5V18h-3.5v8.108c5.891-.583 10.5-5.553 10.5-11.608"
    />
  </svg>
);
export default SvgMdiFacebook;
